import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { Sign } from '../../data/signs';
interface SignDescubrirProps {
  sign: Sign;
}
const INCLUDED = ['Perfil profundo del arquetipo', 'Energía dominante', 'Patrones emocionales', 'Lado oculto', 'Compatibilidad base', 'Frases de identidad', 'Ritual simbólico'];
export function SignDescubrir({
  sign
}: SignDescubrirProps) {
  const items = sign.content.descubriras;
  return <section className="py-20 md:py-28 px-4 md:px-6 bg-cosmic-black" data-id="element-893">
      <div className="container mx-auto max-w-5xl" data-id="element-894">
        <AnimatedSection data-id="element-895">
          {/* Intro text above title */}
          <div className="text-center mb-8 md:mb-10 px-2" data-id="element-896">
            <motion.div className="inline-flex items-center gap-3 mb-6" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} data-id="element-897">
              <div className="h-px w-10 md:w-12" style={{
              background: `linear-gradient(90deg, transparent, ${sign.colors.primary})`
            }} data-id="element-898" />
              <span className="tracking-[0.4em] uppercase font-serif text-[14px]" style={{
              color: sign.colors.accent
            }} data-id="element-899">
                El Núcleo
              </span>
              <div className="h-px w-10 md:w-12" style={{
              background: `linear-gradient(90deg, ${sign.colors.primary}, transparent)`
            }} data-id="element-900" />
            </motion.div>
            <p className="max-w-2xl mx-auto text-lg md:text-xl font-serif italic leading-relaxed mb-10 md:mb-12" style={{
            color: `${sign.colors.accent}E0`,
            textShadow: `0 0 20px ${sign.colors.primary}30`
          }} data-id="element-901">
              El Núcleo del Arquetipo explora los patrones, emociones y energía
              que definen la esencia de tu identidad.
            </p>
          </div>

          <h2 className="text-4xl md:text-5xl font-serif font-bold text-center text-white mb-12 md:mb-16" data-id="element-902">
            Qué Descubrirás
          </h2>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-903">
          {items.map((item, index) => <AnimatedSection key={index} delay={0.15 + index * 0.08} data-id="element-904">
              <GlowCard glowColor={sign.colors.primary} className="h-full flex items-center p-5 md:p-6" data-id="element-905">
                <div className="flex items-start" data-id="element-906">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center flex-shrink-0 mr-4 md:mr-5" style={{
                backgroundColor: `${sign.colors.primary}25`,
                border: `2px solid ${sign.colors.primary}`,
                boxShadow: `0 0 15px ${sign.colors.primary}40`
              }} data-id="element-907">
                    <span style={{
                  color: sign.colors.accent
                }} className="font-bold font-serif text-lg" data-id="element-908">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-gray-100 text-base md:text-lg leading-relaxed pt-1 md:pt-2 font-serif" data-id="element-909">
                    {item}
                  </p>
                </div>
              </GlowCard>
            </AnimatedSection>)}
        </div>

        {/* "Incluido dentro del Núcleo" — premium informational block */}
        <AnimatedSection delay={0.4} data-id="element-910">
          <div className="mt-20 md:mt-28 max-w-4xl mx-auto" data-id="element-911">
            <div className="text-center mb-10 md:mb-12" data-id="element-912">
              <motion.div className="inline-flex items-center gap-3 mb-6" initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} data-id="element-913">
                <div className="h-px w-10" style={{
                background: `linear-gradient(90deg, transparent, ${sign.colors.primary})`
              }} data-id="element-914" />
                <span className="tracking-[0.4em] uppercase font-serif text-[14px]" style={{
                color: sign.colors.accent
              }} data-id="element-915">
                  Contenido del Archivo
                </span>
                <div className="h-px w-10" style={{
                background: `linear-gradient(90deg, ${sign.colors.primary}, transparent)`
              }} data-id="element-916" />
              </motion.div>
              <h3 className="text-3xl md:text-4xl font-serif font-semibold text-white" data-id="element-917">
                Incluido dentro del Núcleo
              </h3>
            </div>

            <div className="relative rounded-2xl p-6 md:p-12 overflow-hidden" style={{
            background: `linear-gradient(160deg, rgba(10,10,18,0.85) 0%, ${sign.colors.primary}10 100%)`,
            border: `1px solid ${sign.colors.primary}35`,
            boxShadow: `0 0 40px ${sign.colors.primary}20, inset 0 0 30px ${sign.colors.primary}08`
          }} data-id="element-918">
              {/* Pulsing ambient glow */}
              <motion.div className="absolute inset-0 rounded-2xl pointer-events-none" animate={{
              opacity: [0.3, 0.55, 0.3]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} style={{
              boxShadow: `inset 0 0 50px ${sign.colors.primary}20`
            }} data-id="element-919" />

              <ul className="relative grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-2 md:gap-y-0" data-id="element-920">
                {INCLUDED.map((item, i) => <motion.li key={item} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.1 + i * 0.08
              }} className="flex items-center py-4 group" style={{
                borderBottom: i < INCLUDED.length - (INCLUDED.length % 2 === 0 ? 2 : 1) ? `1px solid ${sign.colors.primary}20` : 'none'
              }} data-id="element-921">
                    {/* Glowing diamond bullet */}
                    <div className="relative flex-shrink-0 mr-5 w-3 h-3" data-id="element-922">
                      <motion.div className="absolute inset-0" animate={{
                    rotate: 360
                  }} transition={{
                    duration: 12,
                    repeat: Infinity,
                    ease: 'linear'
                  }} style={{
                    backgroundColor: sign.colors.primary,
                    transform: 'rotate(45deg)',
                    boxShadow: `0 0 10px ${sign.colors.primary}`
                  }} data-id="element-923" />
                    </div>
                    <span className="font-serif text-lg md:text-xl tracking-wide" style={{
                  color: '#F5F0E1',
                  textShadow: `0 0 12px ${sign.colors.primary}25`
                }} data-id="element-924">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}